export default class Number {
   /**
    * Генерирует случайное целое число в диапазоне значений между минимальным и
    * максимальным не включая максимальное
    *
    * @param min - минимальное значение
    * @param max - максимальное значение
    * @returns {number} - целое случайное число
    */
   static getRandomInt = (min, max) => parseInt(Math.floor(Math.random() * (max - min)) + min)
}